<template>
    <div class="container container--grid">
        <div class="col-span-4 relative | sm:hidden">
            <div class="absolute z-10 w-full flex justify-between" style="margin-top: 4px">
                <svg class="arrow arrow--left changeMakersCarousel__left cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.413 77.338">
                    <g id="Group_206" data-name="Group 206" transform="translate(0 1.414)">
                        <path id="Path_182" data-name="Path 182" d="M-10068.383-12686.406h72.585" transform="translate(10068.383 12723.662)" fill="none" stroke="#000" stroke-width="4"/>
                        <path id="Path_183" data-name="Path 183" d="M-10015.158-12732.078l37.255,37.255-37.255,37.255" transform="translate(10050.488 12732.078)" fill="none" stroke="#000" stroke-width="4"/>
                    </g>
                </svg>

                <svg class="arrow changeMakersCarousel__right cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.413 77.338">
                    <g id="Group_206" data-name="Group 206" transform="translate(0 1.414)">
                        <path id="Path_182" data-name="Path 182" d="M-10068.383-12686.406h72.585" transform="translate(10068.383 12723.662)" fill="none" stroke="#000" stroke-width="4"/>
                        <path id="Path_183" data-name="Path 183" d="M-10015.158-12732.078l37.255,37.255-37.255,37.255" transform="translate(10050.488 12732.078)" fill="none" stroke="#000" stroke-width="4"/>
                    </g>
                </svg>
            </div>
        </div>
        
        <div class="col-span-4 w-full relative | sm:hidden">
            <div class="w-full swiper changeMakersCarousel">
                <div class="swiper-wrapper">
                    <div v-for="(group, indexGroup) in groups" :key="group.name" class="swiper-slide">
                        <div class="w-full flex flex-col gap-y-[30px]">
                            <span class="uppercase text-15 bg-white py-2 px-5 mb-16 mx-auto" v-html="group.name"></span>

                            <div v-for="(member, indexMember) in group.members" :key="indexMember" v-show="member.name">
                                <span @click="setCurrentSlide(indexGroup, indexMember, $event)" class="underline decoration-1 underline-offset-2 text-30 leading-none cursor-pointer flex justify-between">
                                    {{member.name}}
                                 <span class="block w-[39px] h-[39px] transform transition-transform" :class="{'rotate-45' : currentSlide.group === indexGroup && currentSlide.member === indexMember }">
                                     <svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39">
                                      <g id="Group_1225" data-name="Group 1225" transform="translate(15478 14863.434)">
                                        <circle id="Ellipse_50" data-name="Ellipse 50" cx="19.5" cy="19.5" r="19.5" transform="translate(-15478 -14863.434)" fill="#fff"/>
                                        <g id="Group_700" data-name="Group 700" transform="translate(-15447.442 -14855.093) rotate(90)">
                                          <path id="Path_1525" data-name="Path 1525" d="M-15465-14857.669v22.547" transform="translate(15476.272 14857.669)" fill="none" stroke="#77a2ff" stroke-width="1"/>
                                          <path id="Path_1526" data-name="Path 1526" d="M0,0V22.547" transform="translate(22.547 11.273) rotate(90)" fill="none" stroke="#77a2ff" stroke-width="1"/>
                                        </g>
                                      </g>
                                    </svg>
                                </span>
                                </span>
                                
                                <SlideToggle :data="member" :open="currentSlide.group === indexGroup && currentSlide.member === indexMember"></SlideToggle>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="col-start-2 col-span-5 overflow-y-auto max-h-[700px] scrollbar hidden pl-8 | sm:block | xxl:mr-[59px] xxl:pl-8 xxl:col-start-2 xxl:col-span-4" style="direction: rtl;">
            <div class="flex flex-col mb-10 gap-y-2 text-large leading-xsmall | md:mb-[89px] m | lg:mb-16 lg:gap-y-3 | xxl:mb-[89px]" style="direction: ltr;" v-for="(group, indexGroup) in groups" :key="group.name">
                <span class="
                    uppercase text-10 bg-white mr-auto py-1 px-4 mb-4
                    md:py-1.5 | lg:py-2 lg:px-5
                    xxl:text-14 xxl:leading-none xxl:py-[9px] xxl:px-6 xxl:mb-9" v-html="group.name"></span>
                <span 
                    class="relative text-20 cursor-pointer group hover:text-white | md:pr-14 md:text-28 md:leading-none | xxl:text-40 xxl:pr-20" 
                    :class="{'text-white' : active === `${index}-${indexGroup}` }"
                    v-for="(item, index) in group.members" 
                    :key="item.name"
                    v-show="item.name"
                    @mouseover="active = `${index}-${indexGroup}`"
                    @click="active = `${index}-${indexGroup}`"
                >
                    {{ item.name }}
                    <svg 
                        class="absolute arrow arrow--right right-0 top-1/2 -translate-y-1/2 w-20 group-hover:block" 
                        :class="{ 'block' : active === `${index}-${indexGroup}`, 'hidden' : active !== `${index}-${indexGroup}`}"
                        viewBox="0 0 75.413 77.338"
                    >
                        <g transform="translate(0 1.414)">
                            <path d="M-10068.383-12686.406h72.585" transform="translate(10068.383 12723.662)" fill="none" stroke="#fff" stroke-width="4"/>
                            <path d="M-10015.158-12732.078l37.255,37.255-37.255,37.255" transform="translate(10050.488 12732.078)" fill="none" stroke="#fff" stroke-width="4"/>
                        </g>
                    </svg>
                </span>
            </div>
        </div>

        <div class="col-start-8 col-span-5 hidden | sm:block">
            <div v-for="(group, indexGroup) in groups" :key="group.name">
                <div v-for="(item, index) in group.members" :key="item.name" v-show="active === `${index}-${indexGroup}`">
                    <div class="relative overflow-hidden mb-3.5 | md:mb-6 | xxl:mb-10" style="--aspect-ratio: 1.448;" v-if="item.image">
                        <img class="absolute left-0 top-0 w-full h-full object-cover object-center" :src="item.image.url" :alt="item.image.alt">
                    </div>

                    <h3 class="heading--medium font-black font-Midight24 mb-3.5 | md:mb-6 | xxl:mb-6" v-html="item.name"></h3>

                    <div class="wysiwyg wysiwyg--normal-link wysiwyg--black-link wysiwyg--black">
                        <p class="flex relative"><span class="absolute -left-[60px] | lg:-left-[78px] | xxl:-left-[102px]" v-if="item.history">History:</span> {{ item.history }}</p>
                        <p class="flex relative"><span class="absolute -left-[60px] | lg:-left-[78px] | xxl:-left-[102px]" v-if="item.mission">Mission:</span> {{ item.mission }}</p>
                        <p class="flex relative">
                            <span class="absolute -left-[76px] | lg:-left-[93px] | xxl:-left-[102px]" v-if="item.founders">Founders:</span>
                            <span class="mr-5 text-black" v-for="founder in item.founders" :key="founder.name" v-html="founder.name"></span> 
                        </p>
                    </div>
                    <a :href="item.link.url" class="link link--white mt-4 inline-block | lg:mt-8 | xxl:mt-12" v-html="item.link.title" v-if="item.link" :target="[item.link.target === '_blank' ? item.link.target : '_self']"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SlideToggle from "./partials/SlideToggle";

export default {
    name: 'changemakers',
    props: ['groups'],
    data() {
        return {
            active: '0-0',
            currentSlide: {
                group: null,
                member: null,
            },
        }
    },
    methods: {
        setCurrentSlide(group, member, event){
            if ( group === this.currentSlide.group && member === this.currentSlide.member ) {
                this.currentSlide.group = null;
                this.currentSlide.member = null;
            } else {
                this.currentSlide.group = group;
                this.currentSlide.member = member;

                setTimeout(() => {
                    const offsetTop = $(event.target).offset().top;

                    scroll({
                        top: offsetTop - 145,
                        behavior: "smooth"
                    });
                }, 1000);
            }
        },
    },
    components: { SlideToggle },
}
</script>

<style styles="sass" scoped>
.swiper-button-disabled {
    opacity: 0;
}
</style>